<div class="container mt-4">
    <section id="book-list">
        <h2>Book List</h2>
        <div class="row">
            <div class="col-md-4" *ngFor="let book of bookList">
                <div class="card mb-4">
                    <div class="card-body">
                        <h5 class="card-title">{{ book.title }}</h5>
                        <p class="card-text">Author: {{ book.author }}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section id="sports-data" class="mt-5">
        <h2>Sports Data</h2>
        <table class="table">
            <tbody>
                <tr *ngFor="let data of sportsData | keyvalue">
                    <td>{{ data.key }}</td>
                    <td>{{ data.value }}</td>
                </tr>
            </tbody>
        </table>
    </section>

    <section id="computer-setup" class="mt-5">
        <h2>Computer Setup</h2>
        <div class="row">
            <div class="col-md-4" *ngFor="let item of computerSetup">
                <div class="card mb-4">
                    <div class="card-body">
                        <h5 class="card-title">{{ item.item }}</h5>
                        <p class="card-text">Model: {{ item.model }}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
